import styled from 'styled-components'
import {deviceMax} from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import MapMarkerIcon from '../../images/icons/map-marker.svg'

export const StyledMapContainer = styled.a`
  display: block;
  position: relative;
  width: fit-content;
  margin: 0;
  padding: 0;
`

export const StyledContainer = styled.div`
  border-radius: ${pxToRem(5)};
  width: 100%;
  max-width: ${pxToRem(384)};
  margin: ${pxToRem(10)};
  background-color: ${({theme}) => theme.colors.unique.white};
  @media ${deviceMax.mobileL} {
    width: 100%;
    margin: ${pxToRem(10)} 0;
    height: fit-content;
  }
`

export const StyledStaticMap = styled.img`
  border-radius: ${pxToRem(5)};
`

export const StyledMapMarkerIcon = styled(MapMarkerIcon)`
  position: absolute;
  inset: 0;
  margin: auto;
`

export const StyledInfosContainer = styled.div`
  border-radius: ${pxToRem(5)};
  padding: ${pxToRem(10)};
`
export const StyledInfosBloc = styled.a`
  align-items: center;
  display: flex;
  margin: ${pxToRem(10)} 0;
`
export const StyledInfos = styled.div`
  gap: ${pxToRem(2)};
  flex-direction: column;
  display: flex;
  font: ${({theme}) => theme.fonts.sizes.base};
  font-weight: ${({theme}) => theme.fonts.weight.normal};
  line-height: ${({theme}) => theme.fonts.lineHeight.base};
`
export const StyledIcon = styled.div`
  margin-right: ${pxToRem(10)};
  display: flex;
  align-items: center;
`
